module.exports = __webpack_public_path__ + "static/media/medbikri.811ffebd.svg";